import Model from "../Model";

class Comercialzonetops extends Model{

    buildUrl ({ param }) {
        return ['/zoneview/topzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialzonetops;